import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '../store'
import axios from 'axios'
import i18n from '@/plugins/i18n';
import moment from 'moment';
import OpenReplay from '@openreplay/tracker';
import OpenReplayAxios from '@openreplay/tracker-axios';

// OpenReplay
const tracker = new OpenReplay({
  //__DISABLE_SECURE_MODE: true,
  projectKey: 'oGM9PVWI634HPLr8Rqzg',
  ingestPoint: 'https://openreplay.bbsystems.dk/ingest',
  obscureTextEmails: false,
  obscureTextNumbers: false,
  obscureInputEmails: false,
  obscureInputNumbers: false
});
tracker.use(OpenReplayAxios({
  failuresOnly: false,
}));
tracker.start();

Vue.prototype.tracker = tracker;

// Produktion
//axios.defaults.baseURL = 'https://bookingapi2.bbhotels.dk/api/v3';                
//Vue.prototype.backendurl = 'https://bookingapi2.bbhotels.dk';
//Vue.prototype.frontendurl = 'https://booking2.bbhotels.dk';

// Kunder / Demo
axios.defaults.baseURL = 'https://api.kunder.bbsystems.dk/api/v3';
Vue.prototype.backendurl = 'https://api.kunder.bbsystems.dk';
Vue.prototype.frontendurl = 'http://v2.kunder.bbsystems.dk';

// Udvikling - Lokal server 172.16.9.107
//axios.defaults.baseURL = 'http://bookingapi.udvikling.bbhotels.dk:81/api/v2';
//Vue.prototype.backendurl = 'http://bookingapi.udvikling.bbhotels.dk:81';
//Vue.prototype.frontendurl = 'https://booking2.bbhotels.dk';

Vue.prototype.$http = axios;
Vue.prototype.$http.defaults.headers.get['Content-Type'] = 'application/json';
Vue.prototype.$http.defaults.headers.post['Content-Type'] = 'application/json';

Vue.prototype.moment = moment

Vue.config.productionTip = false

new Vue({
  i18n,

  // Hent translations for hvert sprog fra API
  async beforeCreate() {
    console.log('Koncern: ');
    console.log(this.$route.params.koncern);
    const vm = this;
    await axios.get(axios.defaults.baseURL+'/'+this.$route.params.koncern+'/translations')
      .then((response) => {
        console.log(response.data);
        vm.$i18n.setLocaleMessage('da', response.data.da);
        vm.$i18n.setLocaleMessage('en', response.data.en);
        vm.$i18n.setLocaleMessage('de', response.data.de);
    });
  },

  
  fallbackLocale: 'en',
  router,
  store,
  axios,
  moment,
  render: h => h(App)
}).$mount('#app')
